import { z } from "zod";

export const SESSION_EXPIRED_MESSAGE = "Your session has expired. Please log in again.";
export const FORBIDDEN_MESSAGE = "You don't have permission to perform this action.";
export const SERVER_ERROR_MESSAGE = "Something went wrong on our end. Please try again in a moment.";
export const REQUEST_FAILED_MESSAGE = "Something went wrong. Please try again";

export class HttpError extends Error {
  status: number;
  body: string;

  constructor(status: number, message: string, body: string) {
    super(message);
    this.status = status;
    this.body = body;
  }
}

export function isHttpError(value: unknown): value is HttpError {
  return value instanceof HttpError;
}

const ServerErrorEnvelope = z.object({
  error: z.string().min(1).optional().catch(undefined),
  message: z.string().min(1).optional().catch(undefined),
});

export function serverMessageSafeToShow(status: number | undefined, body: string | undefined): string | null {
  if (status === 401 || (status !== undefined && status >= 500)) return null;
  try {
    const envelope = ServerErrorEnvelope.safeParse(JSON.parse(body ?? ""));
    if (!envelope.success) return null;
    return envelope.data.error ?? envelope.data.message ?? null;
  } catch {
    return null;
  }
}

export function makeHttpError(status: number, body: string): HttpError {
  if (status === 401) return new HttpError(status, SESSION_EXPIRED_MESSAGE, body);
  if (status === 403) return new HttpError(status, FORBIDDEN_MESSAGE, body);
  if (status >= 500) return new HttpError(status, SERVER_ERROR_MESSAGE, body);
  return new HttpError(status, REQUEST_FAILED_MESSAGE, body);
}
